import script from "./AppMtsOpros.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMtsOpros.vue?vue&type=script&setup=true&lang=js"

import "./AppMtsOpros.vue?vue&type=style&index=0&id=3651bee2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3651bee2"]])

export default __exports__